/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsDesigners = {
  init: function($section) {
    // Add settings from schema to current object
    Shopify.theme.jsDesigners = $.extend(this, Shopify.theme.getSectionData($section));
  	const $htmlWapper = $section.find('.vendors__list-wrapper');
    let vendors = this.vendors;
    let numberOfRows = this.row_numbers;
    let startNextColumn = Number(numberOfRows) - 1;

    
    vendors.sort(function(a, b) {
      return a[0].localeCompare(b[0]);
    });
  	
  	var allVendors = {};
    
  	for (var i = 0; i < vendors.length; i++) {
      var c = vendors[i][0].toUpperCase();
      if (allVendors[c] && allVendors[c].length >= 0)
        allVendors[c].push(vendors[i]);
      else {
        allVendors[c] = [];
        allVendors[c].push(vendors[i]);
      }
    }
  
    var vendorhtml = '';
  	var k = 0;
  	var j = 0;
    $.each(allVendors, (index, vend) => {
      
      if(k == 0 || k % numberOfRows == 0){
        vendorhtml += '<div class="column one-sixth medium-down--one-whole">';
        j = 0;
      }

      vendorhtml += '<div class="wrapper has-padding-top has-padding-bottom">';
      var i = 0;

// target="_blank"       
      $.each(vend, (index, alphvend) => {
        if(i==0){ vendorhtml += '<h2 class="desginer-heading">'+alphvend.charAt(0)+'</h2>'; }
        vendorhtml += '<p><a href="https://libastyle.com/collections/vendors/?q='+ alphvend +'">'+ alphvend + '</a></p>';
        i++;        
      });     
      vendorhtml += '</div>';
      // console.log(j,k);
      if(j == startNextColumn){
        vendorhtml += '</div>';
      } j++; k++;
      
      // console.log(vendorhtml);
    });
  
  $htmlWapper.html(vendorhtml);
  
    
  },
  unload: function($section) {

  }
}

/******/ })()
;